// ONE source of truth for the public careers site's page width + horizontal inset.
// Every public marketing surface (header, page content, footer) imports these so the
// header, body, and footer share the same column edges on every page — no page is
// narrower than another, and the whole site reads as full-width on a laptop display.
// Tune the width here and it moves everywhere. Pure module (no "use client", no imports)
// so server and client components can both read it.

/** Max content column for the public careers site. Wide enough to fill a laptop display
 *  while capping line length on ultra-wide monitors. */
export const CAREERS_MAX_W = 1600

/** Shared horizontal page inset (gutter), matching MarketingHeader. */
export const CAREERS_INSET = "clamp(16px, 4vw, 48px)"
